<template>
  <a-modal
    :title="title"
    :width="870"
    :visible="visible"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="eval-preview">
      <div class="content">
        <!--        <div class="title">{{ previewEvalData.name }}</div>-->
        <!--        <div class="remark-area">-->
        <!--          <div>简介：</div>-->
        <!--          <div class="remark">-->
        <!--            {{ previewEvalData.remark }}-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="topic-desc">测评内容</div>-->
        <div v-for="(item, index) in dataSource" :key="index">
          <div :class="{ topic: true }">
            <!--            <span>{{ index + 1 }}、</span>-->
            <span>{{ item.name }}</span>
          </div>
          <div class="select-area">
            <a-radio-group
              v-for="(optItem, optIndex) in item.topicArr"
              :key="optIndex"
              v-model="selectMode[index]"
              :disabled="true"
            >
              <a-radio :value="`${optItem.id}`">
                <span style="color: rgba(0, 0, 0, 0.65)">{{ optItem.name }}</span>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from '@api/manage'

export default {
  name: 'EvalPreviewModal',
  props: {
    title: {
      type: String,
      default: '评测记录',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    topicObj: {
      type: Object,
      default: () => ({}),
    },
    remindStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      dataSource: [],
      selectMode: [],
      recordList: [],
      topicStoreArr: [],
      previewEvalData: {},
    }
  },
  components: {},
  methods: {
    showModal(data = {}) {
      this.visible = true
      this.previewEvalData = data
      console.log('previewEvalData', this.previewEvalData)
      this.getEvalTopic()
    },
    getEvalTopic() {
      // 每次打开先清空，避免上一次弹窗的数据残留造成错位回显
      this.dataSource = []
      this.recordList = []
      this.selectMode = []
      // 两个接口并行且返回顺序互不相关，先各自存原始数据，等题目数据就绪后统一按 questionId 归位
      if (this.previewEvalData.id) {
        getAction('/schoolEvaluationDetail/list', {
          recordId: this.previewEvalData.id,
        }).then((res) => {
          console.log('res--', res)
          if (res.success) {
            this.recordList = res.result || []
            this.buildSelectMode()
          }
        })
      }
      if (this.previewEvalData.evaluationId) {
        getAction('/schoolEvaluationQuestion/getByEvaluationId', {
          evaluationId: this.previewEvalData.evaluationId,
        }).then((res) => {
          if (res.success) {
            this.dataSource = res.result?.map((item) => ({
              ...item,
              topicArr: item.schoolEvaluationAnswerOptionsList,
            })) || []
            console.log('元数据：', this.dataSource)
            this.buildSelectMode()
          }
        })
      }
    },
    // 答案按 questionId 找到对应题目，再把 optionsId 回填到该题下标上，保证与题目接口顺序一致
    buildSelectMode() {
      if (!this.dataSource.length || !this.recordList.length) return
      const answerMap = this.recordList.reduce((map, item) => {
        map[item.questionId] = item.optionsId
        return map
      }, {})
      this.selectMode = this.dataSource.map((topic) => answerMap[topic.id])
      console.log(this.selectMode, 'selectMode')
    },
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const params = { ...this.form, type: this.actionType }
        const res = this.form.id
          ? await putAction(this.actionUrl + '/edit', params)
          : await postAction(this.actionUrl + '/add', params)
        console.log('创建：', res)
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('refreshData')
        } else {
          this.$message.error(res.message)
        }
        this.visible = false
      })
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
<style scoped lang="less">
.eval-preview {
  height: 70vh;
  overflow-y: auto;
}
.topic {
  font-size: 15px;
  line-height: 20px;
}
.topic-active {
  color: #fff;
  // 背景色渐变，同时设置角度
  background: linear-gradient(to right, #f76668, #fc9193);
  padding: 10px;
  border-radius: 8px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: #717378;
}
.topic-desc {
  margin: 20px 0;
  font-size: 16px;
  font-weight: 600;
  color: #717378;
}
.select-area {
  margin: 20px;
  margin-bottom: 30px;
}
.content {
  height: 100%;
  padding: 20px;
  background-color: #f2f6ff;
  border-radius: 8px;
  overflow: hidden;
  overflow-y: auto;
}
.remark-area {
  max-width: 100%;
  padding: 15px 0;
  margin: 15px 0;
  border-top: 1px solid #ebecef;
  border-bottom: 1px solid #ebecef;
  font-size: 15px;
  .remark {
    max-width: 100%;
    color: #b4bdd3;
  }
}
</style>
